import React from "react";
import WideContainer from "../../components/WideContainer";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import DoneIcon from "@mui/icons-material/Done";
import Backdrop from "@mui/material/Backdrop";
import Checkbox from "@mui/material/Checkbox";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import {
  Player,
  ControlBar,
  BigPlayButton,
  LoadingSpinner,
  PlayToggle,
  VolumeMenuButton,
  FullscreenToggle,
  CurrentTimeDisplay,
  TimeDivider,
  DurationDisplay,
  ProgressControl,
} from "video-react";

import axios from "../../components/Axios";
import "./Tracks.css";
import { logos, fetchLogos } from "../../slices/logos";

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 0,
      items: [],
      loading: false,
      loading_edit: false,
      loading_names: false,
      suggest_names: [],
      editNameValue: "",
      editName: false,
      trackDialog: false,
      trackDialogLeft: 0,
      selectedTrack: false,
      tracks: new Set([]),
      player: {
        duration: 0,
      },
      logoBoxStyle: { opacity: 0 },
    };

    this.handleChange = this.handleChange.bind(this);
    this.addItem = this.addItem.bind(this);
    this.editName = this.editName.bind(this);
    this.deleteTrack = this.deleteTrack.bind(this);
  }

  componentDidMount() {
    //this.setState({ loading: true });
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));
    this.props.dispatch(fetchLogos(this.props.match.params.project_id));
  }

  handleStateChange(state) {
    this.setState({
      player: state,
    });
    if (state.paused === false) {
      this.setState(function (state) {
        state.logoBoxStyle = { opacity: 0 };
        return state;
      });
    }
  }

  getThumbUrl(i) {
    if (i === -1) return "/img/people.png";
    return (
      JSON.parse(localStorage.getItem("user")).user_folder +
      "/" +
      this.props.project.project_folder +
      i
    );
  }
  getPathUrl(i) {
    if (i === -1) return "/img/people.png";
    return (
      JSON.parse(localStorage.getItem("user")).user_folder.split("/")[3] +
      "/" +
      this.props.project.project_folder +
      "/logo_tracks_thumbnails/" +
      i +
      ".jpg"
    );
  }

  handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "char_name") {
      this.setState(function (state) {
        state.editNameValue = value;
        return state;
      });
    }
  }

  addItem() {
    this.setState({ loading_edit: true });
    axios
      .post("/video_project/" + this.props.project.project_id + "/logos", {})
      .then(
        function (response) {
          this.setState({ loading_edit: false });
          this.props.dispatch(
            logos.actions.setItems({
              items: response.data,
            })
          );
        }.bind(this)
      )
      .catch(
        function (error) {
          this.setState({ loading_edit: false });
          console.log(error);
        }.bind(this)
      );
  }

  editName(i) {
    if (this.state.editName) {
      this.setState({ loading_edit: true });
      axios
        .post(
          "/video_project/" +
          this.props.project.project_id +
          "/logo/change_name",
          {
            id: this.props.logos.items[this.state.selected].cluster_id,
            name: this.state.editNameValue,
          }
        )
        .then(
          function (response) {
            this.props.dispatch(
              logos.actions.setItems({ items: response.data })
            );
            this.setState({ loading_edit: false });
          }.bind(this)
        )
        .catch(
          function (error) {
            this.setState({ loading_edit: false });
            console.log(error);
          }.bind(this)
        );
    } else {
      this.setState({
        suggest_names: [],
        editNameValue: this.props.logos.items[this.state.selected].cluster_name,
      });
    }
    this.setState({ editName: !this.state.editName });
  }
  setName(v) {
    let n = v;
    this.setState(function (state) {
      state.editNameValue = n;
      return state;
    });
  }

  deleteItem(i) {
    this.setState({ loading_edit: true });
    axios
      .delete(
        "/video_project/" + this.props.project.project_id + "/logo/" + i,
        {}
      )
      .then(
        function (response) {
          this.setState({ loading_edit: false });
          this.props.dispatch(logos.actions.setItems({ items: response.data }));
        }.bind(this)
      )
      .catch(
        function (error) {
          this.setState({ loading_edit: false });
          console.log(error);
        }.bind(this)
      );
  }

  deleteTrack(i, e) {
    e.stopPropagation();
    let t = new Set(this.state.tracks);
    t.add(i);

    this.setState({ loading_edit: true });
    axios
      .post(
        "/video_project/" + this.props.project.project_id + "/logo/move_tracks",
        { id: -1, track_ids: [...t] }
      )
      .then(
        function (response) {
          this.props.dispatch(logos.actions.setItems({ items: response.data }));
          this.setState({
            loading_edit: false,
            tracks: new Set([]),
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          this.setState({ loading_edit: false });
          console.log(error);
        }.bind(this)
      );
  }

  changeTrackDialog(t, e) {
    e.stopPropagation();
    this.setState(function (state) {
      state.tracks.add(t);
      return state;
    });
    this.setState({ trackDialog: true, trackDialogLeft: e.pageX });
  }

  closeTrackDialog() {
    this.setState({ trackDialog: false });
  }

  selectTrack(i) {
    let t = i;
    let rem = this.state.tracks.has(t);
    this.setState(function (state) {
      if (rem) {
        state.tracks.delete(t);
      } else {
        state.tracks.add(t);
      }
      return state;
    });
  }

  setActiveTrack(i) {
    this.setState({ selectedTrack: i });
  }

  changeTrack() {
    this.setState({ trackDialog: false, loading_edit: true });
    axios
      .post(
        "/video_project/" + this.props.project.project_id + "/logo/move_tracks",
        { id: this.state.selectedTrack, track_ids: [...this.state.tracks] }
      )
      .then(
        function (response) {
          this.props.dispatch(logos.actions.setItems({ items: response.data }));
          this.setState({
            loading_edit: false,
            tracks: new Set([]),
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          this.setState({ loading_edit: false });
          console.log(error);
        }.bind(this)
      );
  }

  queryNameChange(i, e) { }

  setActive(i) {
    if (this.state.selected !== i) {
      this.setState({
        selected: i,
        tracks: new Set([]),
        editName: false,
        suggest_names: [],
      });
    } else {
      this.setState({ selected: i });
    }
  }

  formatDuration(s) {
    if (Number.isNaN(s)) return "0:00";

    let pad = function (num, size) {
      return ("000" + num).slice(size * -1);
    },
      time = parseFloat(s).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60);
    if (hours > 0) return hours + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
    else return minutes + ":" + pad(seconds, 2);
  }

  seekVideo(t) {
    this.player.seek(t);
  }

  trackClick(t) {
    this.player.seek(t.start_time + 1 / 30);
    this.player.pause();

    this.setState({
      logoBoxStyle: {
        opacity: 1,
        top: (t.coordinates.t / this.state.player.videoHeight) * 100 + "%",
        left: (t.coordinates.l / this.state.player.videoWidth) * 100 + "%",
        width:
          ((t.coordinates.r - t.coordinates.l) / this.state.player.videoWidth) *
          100 +
          "%",
        height:
          ((t.coordinates.b - t.coordinates.t) /
            this.state.player.videoHeight) *
          100 +
          "%",
      },
    });
  }

  PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  render() {
    return (<>
      <WideContainer style={{ paddingTop: "32px" }}>
        <div
          className="flex"
          style={{
            alignItems: "flex-start",
            alignItems: "stretch",
          }}
        >
          <div className="queryList flex-col mhBody" style={{ margin: "0" }}>
            <div
              className="flex"
              style={{
                paddingRight: "16px",
              }}
            >
              <div className="queryTitle">Logos</div>
              <Button
                variant="outlined"
                endIcon={<AddIcon />}
                hidden={this.props.logos.loading === "pending"}
                onClick={this.addItem}
                disabled={this.state.loading_edit}
              >
                Add
              </Button>
            </div>
            <div style={{ marginTop: "24px", overflow: "auto" }}>
              {this.props.logos.loading === "pending" && (
                <CircularProgress
                  style={{ margin: "40px auto", display: "block" }}
                />
              )}
              {this.props.logos.loading === "idle" &&
                this.props.logos.items.map((i, k) => (
                  <div
                    className={
                      "flex queryRow" +
                      (k === this.state.selected ? " queryRowActive" : "")
                    }
                    key={k}
                    onClick={this.setActive.bind(this, k)}
                  >
                    <div
                      className="LogoListImg"
                      style={{
                        backgroundImage:
                          "url('" +
                          this.getThumbUrl("/logo_thumbnails/" + i.img_path) +
                          "')",
                        margin: "12px 16px 12px 4px",
                      }}
                    />
                    <div style={{ flex: "1" }}>
                      <div className="charName">{i.cluster_name}</div>
                      <div className="charText">
                        {i.tracks.length} occurrences
                      </div>
                    </div>
                    <IconButton
                      color="primary"
                      onClick={this.deleteItem.bind(this, i.cluster_id)}
                      hidden={i.cluster_id == -1}
                      size="large">
                      <DeleteIcon />
                    </IconButton>
                  </div>
                ))}
            </div>
          </div>
          <div
            className="queryBuilder flex-col mhBody"
            style={{ paddingRight: "24px", overflow: "auto" }}
          >
            <div className="playerContainer">
              <div className="logoBox" style={this.state.logoBoxStyle}></div>
              <Player
                ref={(player) => {
                  this.player = player;
                }}
                autoPlay={false}
                src={this.props.videosrc}
              >
                <BigPlayButton position="center" />
                <LoadingSpinner />
                <ControlBar autoHide={false} disableDefaultControls>
                  <PlayToggle key="play-toggle" order={1} />
                  <VolumeMenuButton
                    key="volume-menu-button"
                    order={4}
                    vertical
                  />
                  <CurrentTimeDisplay
                    key="current-time-display"
                    order={5.1}
                  />
                  <DurationDisplay key="duration-display" order={7.3} />
                  <ProgressControl key="progress-control" order={6} />
                  <FullscreenToggle key="fullscreen-toggle" order={8} />
                </ControlBar>
              </Player>
            </div>
            <div className="timelineHighlights"></div>

            {this.state.selected in this.props.logos.items && (
              <>
                <div className="flex">
                  <div
                    className="LogoListImg"
                    style={{
                      backgroundImage:
                        "url('" +
                        this.getThumbUrl(
                          "/logo_thumbnails/" +
                          this.props.logos.items[this.state.selected]
                            .img_path
                        ) +
                        "')",
                      width: "100px",
                      height: "100px",
                      margin: "16px",
                    }}
                  />
                  <div style={{ flex: "1" }}>
                    <div className="charNameTitle">
                      {this.state.editName && (
                        <div
                          className="flex"
                          style={{
                            width: "320px",
                            position: "relative",
                            left: "-8px",
                          }}
                        >
                          <TextField
                            value={this.state.editNameValue}
                            name="char_name"
                            variant="outlined"
                            className="charNameField"
                            autoFocus
                            onChange={this.handleChange}
                            slotProps={{
                              input: {
                                endAdornment: (
                                  <IconButton onClick={this.editName} className="textfieldButton" size="large">
                                    <DoneIcon />
                                  </IconButton>
                                ),
                              }
                            }}
                          />
                        </div>
                      )}
                      {!this.state.editName && (
                        <>
                          {
                            this.props.logos.items[this.state.selected]
                              .cluster_name
                          }
                          <IconButton onClick={this.editName} style={{ marginLeft: "40px" }} size="large">
                            <EditIcon />
                          </IconButton>
                        </>
                      )}
                    </div>
                    <div className="flex suggestedNameList" hidden>
                      {this.state.editName && (
                        <>
                          <div style={{ fontWeight: "bold" }}>
                            Suggested:{" "}
                          </div>
                          <div className="flex" style={{ flex: "1" }}>
                            {this.state.loading_names && (
                              <CircularProgress
                                size={20}
                                style={{ margin: "0 8px" }}
                              ></CircularProgress>
                            )}
                            {this.state.suggest_names.map((v) => (
                              <div
                                key={"sn-" + v}
                                className="suggestedName"
                                onClick={this.setName.bind(this, v)}
                              >
                                {v}
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                      <div style={{ height: "22px" }} />
                    </div>
                    <div className="charText">
                      {
                        this.props.logos.items[this.state.selected].tracks
                          .length
                      }{" "}
                      occurrences
                    </div>
                  </div>
                </div>
                <div className="faceTracks">Logo Tracks</div>
                <div
                  className="flex faceTracksFlex"
                  style={{ minHeight: "300px" }}
                >
                  {this.props.logos.items[this.state.selected].tracks.map(
                    (v) => (
                      <div
                        key={"thumb" + v.logo_track_id}
                        className="LogoListImg"
                        data-selected={this.state.tracks.has(v.logo_track_id)}
                        style={{
                          backgroundImage:
                            "url('" +
                            this.getThumbUrl(
                              "/logo_tracks_thumbnails/" +
                              v.track_thumbnail_path
                            ) +
                            "')",
                          width: "100px",
                          height: "100px",
                        }}
                        /*onClick={this.selectTrack.bind(this, v.logo_track_id)}*/
                        onClick={this.trackClick.bind(this, v)}
                      >
                        <div
                          className="clipCheckbox"
                          onClick={this.selectTrack.bind(
                            this,
                            v.logo_track_id
                          )}
                        >
                          <div className="clipCheckboxBg"></div>
                          <Checkbox
                            color="primary"
                            checked={this.state.tracks.has(v.logo_track_id)}
                          />
                        </div>
                        <div
                          className="imgBtn"
                          style={{ top: "4px", right: "38px" }}
                          onClick={this.changeTrackDialog.bind(
                            this,
                            v.logo_track_id
                          )}
                        >
                          <AssignmentIndIcon fontSize="small" />
                        </div>
                        <div
                          className="imgBtn"
                          style={{ top: "4px", right: "4px" }}
                          onClick={this.deleteTrack.bind(
                            this,
                            v.logo_track_id
                          )}
                          hidden={
                            this.props.logos.items[this.state.selected]
                              .cluster_id == -1
                          }
                        >
                          <DeleteIcon fontSize="small" />
                        </div>
                        <div className="logoTime">
                          {this.formatDuration(v.start_time)}
                        </div>
                      </div>
                    )
                  )}
                </div>
              </>
            )}
            <div style={{ flex: "1" }}></div>
          </div>
        </div>
      </WideContainer>
      <Dialog
        open={this.state.trackDialog}
        scroll="paper"
        onClose={this.closeTrackDialog.bind(this)}
        style={{
          left: this.state.trackDialogLeft + 32 + "px",
          right: "inherit",
        }}
      >
        <DialogTitle>
          <div
            className="charNameTitle"
            style={{ cursor: "move", padding: "8px" }}
            id="draggable-dialog-title"
          >
            Choose Logo
          </div>
          <div className="newCharDialog" onClick={this.addItem}>
            <div style={{ flex: "1" }}>NEW LOGO</div>
            <AddIcon />
          </div>
        </DialogTitle>
        <DialogContent>
          {this.props.logos.loading === "pending" && (
            <CircularProgress
              style={{ margin: "40px auto", display: "block" }}
            />
          )}
          {this.props.logos.loading === "idle" &&
            this.props.logos.items.map((i, k) => (
              <div
                className={
                  "flex trackRow" +
                  (i.cluster_id === this.state.selectedTrack
                    ? " queryRowActive"
                    : "")
                }
                key={"charD" + k}
                onClick={this.setActiveTrack.bind(this, i.cluster_id)}
              >
                <div
                  className="LogoListImg"
                  style={{
                    backgroundImage:
                      "url('" +
                      this.getThumbUrl("/logo_thumbnails/" + i.img_path) +
                      "')",
                    margin: "8px 16px 8px 0",
                  }}
                />
                <div style={{ flex: "1" }}>
                  <div className="charName">{i.cluster_name}</div>
                </div>
              </div>
            ))}
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={this.closeTrackDialog.bind(this)}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={this.changeTrack.bind(this)}
            color="primary"
            disabled={this.state.selectedTrack === false}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop open={this.state.loading_edit} className="loadingBackDrop">
        <CircularProgress color="inherit" />
      </Backdrop>
    </>);
  }
}

const mapState = (state) => {
  return {
    characters: state.characters,
    logos: state.logos,
  };
};
export default withRouter(connect(mapState)(Index));
